<form [formGroup]="form.formGroup" class="flex flex-col space-y-2 overflow-hidden">

    <div class="flex flex-col">
      <div class="flex items-center space-x-2">
        <p-checkbox size="small" [formControlName]="form.formControlNames.sealBoreBelowPacker" (onChange)="sealBoreBelowPackerChecked($event)" inputId="sealBoreBelowPacker" binary="true"/>
        <label for="sealBoreBelowPacker"> Seal Bore below Packer</label>
      </div>
    </div>

  <div class="flex space-x-2">
    <p-checkbox tooltipPosition="left" [class.opacity-50]="control('sealBoreBelowPacker').value == true" [class.pointer-events-none]="control('sealBoreBelowPacker').value == true" (onChange)="pbrAtPackerChange($event)" size="small" [formControlName]="form.formControlNames.isDepthNotAtPacker" pTooltip="Depth not at Packer" inputId="depthAtPacker"
      binary="true" class="mt-3.5" />

    <div class="flex flex-col w-full">
      <div class="flex space-x-2">
        <label>Depth</label>
          <i pTooltip="If depth is above Packer, then telescoping Expansion Joint is assumed with properties determined by the string specified in Well Configuration"
            class="pi pi-info-circle cursor-help">
        </i>
      </div>

        <app-validated-number-input
          [id]="'measuredDepth'"
          [control]="control('measuredDepth')"
          [value]="control('measuredDepth').value"
          [readonly]="!control('isDepthNotAtPacker').value"
          [validation]="{ max: packerDepth - 1 }"
          [unit]="userUnits?.longLengths || 'ft'"
        ></app-validated-number-input>
    </div>
  </div>

  <div class="flex flex-col">
    <label>Seal Contact Diameter</label>
    <app-validated-number-input
      [id]="'sealBoreContactDiameter'"
      [control]="control('sealBoreContactDiameter')"
      [value]="control('sealBoreContactDiameter').value"
      [validation]="{ min: 0, max: 10000000 }"
      [unit]="userUnits?.shortLengths || 'in'"
      [unitPrecisionOverrides]="{ 'in': 3, 'cm': 2, 'mm': 2 }"
    ></app-validated-number-input>
  </div>

  <div class="flex items-center space-x-2">
    <p-checkbox (onChange)="isShearedChange($event)" size="small" [formControlName]="form.formControlNames.isSheared" inputId="isSheared"
      binary="true" />
    <label class="pt-1" for="isSheared">Is Sheared / Movement Allowed</label>
  </div>

  <div formGroupName="notShearedState" class="flex flex-col">
    <label>Shear Pin Rating</label>
    <app-validated-number-input
      [id]="'shearPinRating'"
      [control]="control('notShearedState.shearPinRating')"
      [value]="control('notShearedState.shearPinRating').value"
      [readonly]="control('isSheared').value"
      [validation]="{ min: 0, max: 10000000 }"
      [unit]="userUnits?.force || 'lbf'"
    ></app-validated-number-input>
  </div>

  <div formGroupName="movementState" class="flex flex-col">
    <label>Total Stroke Length</label>
    <app-validated-number-input
      [id]="'totalStrokeLength'"
      [control]="control('movementState.totalStrokeLength')"
      [value]="control('movementState.totalStrokeLength').value"
      [readonly]="!control('isSheared').value"
      [validation]="{ min: 0, max: 10000000 }"
      [unit]="userUnits?.longLengths || 'ft'"
      (onChange)="movementLimitChange($event, 'totalStrokeLength')"
    ></app-validated-number-input>
  </div>

  <div formGroupName="movementState" class="flex items-center space-x-2"  [class.opacity-50]="!control('isSheared').value" [class.pointer-events-none]="!control('isSheared').value">
    <p-checkbox size="small" formControlName="hasUpwardNoGo" inputId="hasUpwardNoGo"
      binary="true"/>

    <div class="space-x-2 pt-1">
      <label for="hasUpwardNoGo"> Has Upward No-Go</label>
      <i pTooltip="NOTE: when space-out is specified via No-Go limits for hydraulic-set packers, the space-out shall include length-change effects during the packer setting process.  This will be accurate if space-out is set in the yard prior to deployment to the wellsite."
        class="pi pi-info-circle cursor-help">
      </i>
    </div>
  </div>

  <div formGroupName="movementState" class="flex flex-col">
    <div class="flex space-x-2">
      <label>Space-Out</label>
      <i pTooltip="Space-out is the final upward movement after tagging downward with the landing shoulder. It will be the maximum downward movement limit."
        class="pi pi-info-circle pt-0.5 cursor-help">
      </i>
    </div>
    <app-validated-number-input
      [id]="'spaceOut'"
      [control]="control('movementState.spaceOut')"
      [value]="control('movementState.spaceOut').value"
      [readonly]="!control('isSheared').value"
      [validation]="{ min: 0, max: form.formGroup.get('movementState')?.get('totalStrokeLength')?.value }"
      [unit]="userUnits?.longLengths || 'ft'"
      (onChange)="movementLimitChange($event, 'spaceOut')"
    ></app-validated-number-input>
  </div>

  <label>{{ upwardMovementLimitValue }}</label>

</form>